import { Avatar } from '@chakra-ui/react';
import Content from '@components/content';
import ROUTER from '@constants/router';
import { myInfoSelector } from '@stores/myInfo';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { HiOutlineHome } from 'react-icons/hi';
import { MdDeliveryDining, MdOutlineDragHandle } from 'react-icons/md';
import { RiRefund2Fill } from 'react-icons/ri';
import { useSelector } from 'react-redux';

const FILTER_PATH = ['/restaurants/*/*', '/sign-in'];

export default function Nav() {
  const router = useRouter();
  const [navSize, setNavSize] = useState<'sm' | 'md' | 'lg'>('md');
  const { profileImage } = useSelector(myInfoSelector);

  const patternToRegex = (pattern: string) => {
    let regexPattern = pattern.replace(/\*/g, '[^/]+').replace(/\//g, '\\/');
    return new RegExp('^' + regexPattern + '$');
  };

  const isPathFiltered = (pathname: string) => {
    return FILTER_PATH.some((pattern) => {
      const regex = patternToRegex(pattern);
      return regex.test(pathname);
    });
  };

  const handleNavSize = () => {
    setNavSize((prev) => (prev === 'md' ? 'sm' : 'md'));
  };
  if (isPathFiltered(router.pathname)) return <></>;

  return (
    <nav className="sticky bottom-0 left-0 z-20 bg-white h-fit w-full rounded-t-2xl shadow-[0px_10px_2px_#888,0px_-1px_8px_rgba(125,125,125,0.3)] transition-all duration-200 ease-in-out">
      <div
        className="w-full flex items-center justify-center py-1"
        onClick={handleNavSize}
      >
        <span>
          <MdOutlineDragHandle />
        </span>
      </div>
      {navSize === 'md' && (
        <Content className="w-full pb-2">
          <ul className="flex gap-[8px] px-4 justify-between [&>li>a>div]:flex [&>li>a>div]:gap-[2px] [&>li>a>div]:font-bold [&>li>a>div]:text-[18px]">
            <li className="w-[32px]">
              <Link href="/">
                <div className="flex items-center flex-col h-full">
                  <HiOutlineHome size="28px" />
                  <div className="flex flex-col items-center justify-center h-full flex-1 text-[10px]">
                    <p>Home</p>
                  </div>
                </div>
              </Link>
            </li>
            <li className="w-[32px]">
              <Link href={ROUTER.order}>
                <div className="flex items-center flex-col h-full">
                  <MdDeliveryDining size="28px" />
                  <div className="flex flex-col leading-3 items-center justify-center h-full flex-1 text-[10px]">
                    <p>Order</p>
                    <p>History</p>
                  </div>
                </div>
              </Link>
            </li>
            <li className="w-[32px]">
              <Link href="/refund">
                <div className="flex items-center flex-col h-full">
                  <RiRefund2Fill size="28px" />
                  <div className="flex flex-col items-center justify-center h-full flex-1 text-[10px]">
                    <p>Refund</p>
                  </div>
                </div>
              </Link>
            </li>
            <li className="w-[32px]">
              <Link href="/my-info">
                <div className="flex items-center flex-col h-full">
                  <p className="flex items-center flex-col">
                    <Avatar src={profileImage} h="28px" w="28px" />
                    <div className="flex flex-col leading-3 items-center justify-center h-full flex-1 text-[10px]">
                      <p>My</p>
                      <p>Info</p>
                    </div>
                  </p>
                </div>
              </Link>
            </li>
          </ul>
        </Content>
      )}
    </nav>
  );
}
